module.exports = {
      id: "share-linkedin-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#share-linkedin",
      toString: function () {
        return this.url;
      }
    }